
import { SMAdditionalInfo } from "@/store";
import { computed, defineComponent } from "vue-demi";
import { track } from "@amplitude/analytics-browser";

export default defineComponent({
  name: "PricingServicesPopups",

  components: {
    ServicesBlock: () => import("@/modules/Pricing/Services/ServicesBlock.vue"),
    CoSAllocation: () => import("@/modules/Pricing/Services/Forms/CoSAllocation.vue"),
    CoSAllocationForm: () => import("@/modules/Pricing/Services/Forms/CoSAllocationForm.vue"),
    MockAudit: () => import("@/modules/Pricing/Services/Forms/MockAudit.vue"),
    MockAuditForm: () => import("@/modules/Pricing/Services/Forms/MockAuditForm.vue"),
    PaidConsultation: () => import("@/modules/Pricing/Services/Forms/PaidConsultation.vue"),
    PaidConsultationForm: () => import("@/modules/Pricing/Services/Forms/PaidConsultationForm.vue"),
  },

  setup() {
    const activeService = computed(() => SMAdditionalInfo.pricingServicesActiveService);
    const currentStep = computed(() => SMAdditionalInfo.pricingServicesCurrentStep);
    const showModal = computed(() => SMAdditionalInfo.pricingServicesShowModal);

    function goToForm() {
      SMAdditionalInfo.setPricingServicesCurrentStep("form");

      track("Clicked 'Continue' in the modal", { service: activeService.value });
    }

    function goToSuccess() {
      SMAdditionalInfo.setPricingServicesCurrentStep("success");
    }

    function closeFlow() {
      if (currentStep.value === "success") {
        track("Clicked 'Submit Request'", { service: activeService.value });
      } else {
        track("Closed the modal", { service: activeService.value, step: currentStep.value });
      }

      SMAdditionalInfo.setPricingServicesActiveService(null);
      SMAdditionalInfo.setPricingServicesCurrentStep("intro");
      SMAdditionalInfo.setPricingServicesShowModal(false);
    }

    function goBack() {
      if (currentStep.value === "form") {
        SMAdditionalInfo.setPricingServicesCurrentStep("intro");
      } else {
        closeFlow();
      }
    }

    return {
      activeService,
      currentStep,
      showModal,
      goToForm,
      goToSuccess,
      goBack,
      closeFlow,
    };
  },
});
